import { doc as docRef, updateDoc } from 'firebase/firestore';
import { db as defaultDb } from '../firebase';
import { normalizeRotation } from './rotation';

// Persisting a project's footage rotation. The rotation itself — what the
// angles mean and how they compose — lives in `rotation.js`; this module only
// writes it, mirroring the `ordering.js` / `footageOrder.js` split.

/**
 * Persist the project's footage rotation.
 *
 * One field on the project document, owner-writable per firestore.rules, so
 * this is a single round trip with no callable behind it — the same shape as
 * `persistFootageOrder`. Normalized before writing so a bad angle can never
 * reach the render worker, even though the worker re-checks anyway.
 */
export async function persistFootageRotation(projectId, rotation, {
  db = defaultDb,
  doc = docRef,
  update = updateDoc,
} = {}) {
  const value = normalizeRotation(rotation);
  if (!projectId) return value;
  await update(doc(db, 'projects', projectId), { footageRotation: value });
  return value;
}

export default persistFootageRotation;
